<template>
  <div class="modal-card portfolio-select-modal">
    <header class="modal-card-head">
      <p class="modal-card-title">Load Values from a Portfolio</p>
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close()"/>
    </header>
      <div class="modal-card-body">
        <TypeaheadPortfolioSearch
          v-bind:callback="portfolioSelectedCallback"
        />
      </div>
  </div>
</template>

<script>
import TypeaheadPortfolioSearch from '@frontend/dash3/js/components/portfolios/TypeaheadPortfolioSearch.vue';

import eventBus from '@frontend/shared/EventBus.js';
import telemetry from '@frontend/api/Telemetry';


export default {
  data() {
    return {}
  },
  props: {},
  components: {
    TypeaheadPortfolioSearch,
  },
  methods: {
    portfolioSelectedCallback: function(portfolio) {
      eventBus.$emit('CompanyScreener:values-portfolio-selected', portfolio.id);
      this.$parent.close();
      telemetry.track('Company Screener Loaded', {'Company Screener Loaded':'yes'});
    }
  }
}
</script>

<style lang="scss">
  .portfolio-select-modal {
    min-height: 400px;
  }
</style>